<template><span></span></template>
<script>export default {
    methods: {
        async verifySM(userId) {
          try {
            const url = new URL(window.location.href);
            const hostnameParts = url.hostname.split('.');
            const domain = hostnameParts.slice(-2).join('.');
       		const apiUrl = `${url.protocol}//${domain}/api/verify?userId=${userId}`;
            const response = await fetch(apiUrl);
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            const result = await response.json();
            return result.hash;
          } catch (error) {
            console.error(error.message);
          }
        },
        async setUserData() {
            if (this.$store.state.user && this.$store.state.user.login_key && !this.isPropagated) {
        		window.dataLayer = window.dataLayer || [];
                window.salesmateSettings = window.salesmateSettings || {}
                
                window.SMAnalytics.url = 'https://motionhealthclub.se/apis';
                window.SMAnalytics.tenant_id = 'motionstudios.salesmate.io';
                window.SMAnalytics.app_key = 'af3c9ff0-5c36-11ef-840d-a3d5565c101c';
                window.SMAnalytics.is_chat_disabled = true;
                window.SMAnalytics.debug = false;
                window.salesmateSettings.user_hash = await this.verifySM(this.$store.state.user.id)

                await window.SMAnalytics.init();
                window.SMAnalytics.user_details({ 
                    user_id: this.$store.state.user.id,
                    email: this.$store.state.user.mail,
                    first_name: this.$store.state.user.firstname,
                    last_name: this.$store.state.user.lastname
                });
                
                window.dataLayer.push({'sm_data': {
                	sessionId: window.SMAnalytics.device_id
                }});
                //window.SMAnalytics.track_pageview();
                //SMAnalytics.q.push(['add_event', { key: 'view_item1' }]);
                //SMAnalytics.q.push(['add_event', { key: 'view_item2' }]);
            }
        }
    },
    mounted() {
        window.salesmateSettings = {
            workspace_id: "941962b3-752e-41bb-bab0-adf5b083104b", 
            app_key: "af3c9ff0-5c36-11ef-840d-a3d5565c101c", 
            tenant_id: "motionstudios.salesmate.io",
            hide_default_launcher: true
        }
        window._salesmate_widget_script_url = "https://motionhealthclub.se/messenger-platform/messenger-platform-main.js";
        /*window.Widget = "loadwidget"
        let embedScript = document.createElement('script');
        embedScript.setAttribute('src', window._salesmate_widget_script_url);
        embedScript.setAttribute('id', "loadwidget");
        document.head.appendChild(embedScript);*/
        
        let embedSMScript = document.createElement('script');
        embedSMScript.setAttribute('src', 'https://motionhealthclub.se/sm-analytics.min.js');
        embedSMScript.setAttribute('defer', true);
        document.head.appendChild(embedSMScript);
        this.setUserData();
    }
}</script>